import styled from "styled-components";

const BigText = styled.h2`
  line-height: 150%;
  letter-spacing: 1px;
  font-weight: 500;
`;

export default BigText;
